<template>
  <div class="organigramme-page">

    <!-- Header -->
    <div class="page-header">
      <h1 class="page-title">Organigramme</h1>
      <div class="page-title-bar"></div>
      <p class="page-subtitle">Bureau et Conseil d'Administration de SELIDAIRE</p>
    </div>

    <!-- Bureau -->
    <v-container class="org-container">
      <div class="section-label">
        <v-icon size="16" color="#E65100">mdi-star-circle-outline</v-icon>
        Bureau
      </div>

      <v-row justify="center" class="mb-8">
        <v-col cols="12" sm="6" md="4" v-for="member in bureau" :key="member.name">
          <div class="member-card">
            <div class="member-photo-wrap">
              <v-img :src="require('@/assets/' + member.photo)" cover class="member-photo"></v-img>
              <div class="member-role-badge">{{ member.role }}</div>
            </div>
            <div class="member-info">
              <div class="member-name">{{ member.name }}</div>
            </div>
          </div>
        </v-col>
      </v-row>

      <div class="section-label">
        <v-icon size="16" color="#E65100">mdi-account-group-outline</v-icon>
        Conseil d'Administration
      </div>

      <v-row justify="center">
        <v-col cols="12" sm="6" md="4" v-for="member in conseil" :key="member.name">
          <div class="member-card">
            <div class="member-photo-wrap">
              <v-img :src="require('@/assets/' + member.photo)" cover class="member-photo"></v-img>
              <div class="member-role-badge secondary">{{ member.role }}</div>
            </div>
            <div class="member-info">
              <div class="member-name">{{ member.name }}</div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
export default {
  data () {
    return {
      bureau: [
        { name: 'Michel', role: 'Président', photo: 'michel.jpeg' },
        { name: 'Daniel', role: 'Vice-Président', photo: 'daniel.jpeg' },
        { name: 'Jean-François', role: 'Trésorier', photo: 'jf.jpeg' },
      ],
      conseil: [
        { name: 'Marie-Jeanne', role: 'Administratrice', photo: 'marie_jeanne.jpg' },
        { name: 'Alan', role: 'Administrateur', photo: 'alan.jpg' },
        { name: 'Dominique', role: 'Administrateur', photo: 'dominique.jpg' },
      ]
    }
  }
}
</script>

<style scoped>
.organigramme-page {
  background: #fafafa;
  min-height: 100vh;
}

.page-header {
  padding: 32px 24px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  text-align: center;
}

.page-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #212121;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.page-title-bar {
  width: 40px;
  height: 3px;
  background: #E65100;
  margin: 0 auto 12px;
  border-radius: 2px;
}

.page-subtitle {
  font-size: 0.85rem;
  color: #757575;
  margin: 0;
}

.org-container {
  max-width: 900px;
  padding-top: 36px;
  padding-bottom: 48px;
}

.section-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #E65100;
  margin-bottom: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid #FFE0B2;
}

.member-card {
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  transition: transform 0.2s, box-shadow 0.2s;
}

.member-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(230,81,0,0.15);
}

.member-photo-wrap {
  position: relative;
  height: 220px;
}

.member-photo {
  height: 100%;
  width: 100%;
}

.member-role-badge {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #E65100;
  color: white;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 6px 12px;
  text-align: center;
}

.member-role-badge.secondary {
  background: #BF360C;
}

.member-info {
  padding: 14px 16px;
  text-align: center;
  border-top: 3px solid #E65100;
}

.member-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: #212121;
  letter-spacing: 0.02em;
}
</style>
